import useApiRecord from "hooks/use_api_record"
import { fields, include } from "components/admin/registerable/requestParams"

const useReservation = (id, data = {}) => {
  const path = "reservations"
  const defaultData = {
    fields: {
      ...fields,
      Reservation:
        "attendee_type_selections, attendees, event, responsible_person, expires_at, expires_in_ms, completable, updated_at"
    },
    include
  }

  const { loading, errors, record } = useApiRecord({
    id,
    path,
    data: { ...defaultData, ...data }
  })

  return { loading, errors, reservation: record }
}

export default useReservation
